<template>
  <div class="signup-page">
    <!-- 任务信息 -->
    <div class="task-card">
      <div class="info-line"><span class="row-label">任务名称：</span><span class="row-value">{{ form.projectName }}</span></div>
      <div class="info-line"><span class="row-label">发布企业：</span><span class="row-value">{{ form.merName }}</span></div>
      <div class="info-line"><span class="row-label">服务周期：</span><span class="row-value">{{ form.serviceTime }}</span></div>
    </div>

    <!-- 输入区域 + 确认信息 -->
    <div class="form-group">
      <div class="form-card">
        <van-field v-model="form.name" label="姓名" placeholder="请输入姓名" />
        <van-field v-model="form.mobile" type="tel" label="手机号" placeholder="请输入手机号" maxlength="11" class="borBot" />
      </div>

      <div class="confirm-card">
        <van-checkbox v-model="confirmed">
          <span class="confirm-text">我已确认以上信息，并申请报名该任务</span>
        </van-checkbox>
        <div class="confirm-note">报名后，平台将根据该任务所属企业安排后续审核及签约流程。</div>
      </div>
    </div>

    <!-- 底部按钮（右对齐） -->
    <div class="btn-row">
      <van-button class="btn-cancel" plain @click="$router.back()">取消</van-button>
      <van-button class="btn-submit" @click="confirmSignUp">确认报名</van-button>
    </div>
  </div>
</template>
<script>
import { NavBar } from 'vant'
import requestHomeAPI from '@/axios/HomeApi'

export default {
  name: 'SignUp',
  components: {
    [NavBar.name]: NavBar
  },
  data () {
    return {
      // 报名表单（任务信息来自详情页）
      form: {
        projectId: '',
        merId: '',
        merNo: '',
        projectName: '',
        merName: '',
        serviceTime: '',
        name: '',
        mobile: ''
      },
      // 确认勾选，默认选中
      confirmed: true
    }
  },
  created () {
    const query = this.$route.query || {}
    this.form.projectId = query.projectId || ''
    this.form.merId = query.merId || ''
    this.form.merNo = query.merNo || ''
    this.form.projectName = query.projectName || ''
    this.form.merName = query.merName || ''
    this.form.serviceTime = query.serviceTime || ''
  },
  methods: {
    confirmSignUp () {
      if (!this.form.name) {
        this.$toast('请填写姓名')
        return
      }
      if (!/^1\d{10}$/.test(this.form.mobile)) {
        this.$toast('请填写正确的手机号')
        return
      }
      if (!this.confirmed) {
        this.$toast('请先勾选确认信息')
        return
      }
      // 提交报名
      requestHomeAPI.saveRegistPerson({
        projectId: Number(this.form.projectId),
        name: this.form.name,
        mobile: this.form.mobile,
        merId: Number(this.form.merId),
        merNo: this.form.merNo,
        merName: this.form.merName,
        projectName: this.form.projectName
      }).then(res => {
        if (res.data.code === '0000') {
          this.$toast.success('报名成功')
          // 报名成功跳转到「我的任务」页面
          this.$router.push({ path: '/myTask' })
        } else {
          this.$notify({ type: 'danger', message: res.data.message })
        }
      }).catch(() => {
        this.$notify({ type: 'danger', message: '网络异常，请重试' })
      })
    }
  }
}
</script>
<style scoped lang="less">
/*
 * 注意：项目 postcss 按 750 设计稿宽度将 px 自动转成 vw（src 代码），
 * 即源码数值是设计稿坐标，实际渲染大小 = 数值 ÷ 2。
 */
.signup-page {
  min-height: 100%;
  padding-bottom: 40px;
  background: #f5f5f5;
}

.task-card {
  margin: 20px;
  padding: 32px;
  background: #fff;
  border-radius: 16px;
  text-align: left;

  .info-line {
    font-size: 30px;
    color: #999;
    line-height: 48px;

    /* 左侧标签浅色，右侧内容深色 */
    .row-label {
      color: #999;
    }

    .row-value {
      color: #323233;
    }
  }
}

/* 输入区域 + 确认信息 外层容器 */
.form-group {
  margin: 0 20px;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
}

.form-card {
  /deep/ .van-field__label {
    width: 120px; /* 源码值 → 渲染60px，比默认6.2em更窄 */
    font-size: 30px;
  }

  /deep/ .van-field__control {
    font-size: 30px;
  }
}

.confirm-card {
  margin-top: 20px;
  padding: 32px;
  background: #fff;
  border-radius: 16px;

  .confirm-text {
    font-size: 30px;
    color: #323233;
  }

  .confirm-note {
    margin-top: 16px;
    font-size: 26px;
    color: #999;
    line-height: 40px;
    text-align: left;
  }
}

.btn-row {
  display: flex;
  margin: 20px 20px 0;

  /* 两个按钮等宽平分 */
  .btn-cancel {
    flex: 1;
    font-size: 30px;
    height: 76px;
    border-radius: 16px;
    margin-right: 20px;
  }

  .btn-submit {
    flex: 1;
    font-size: 30px;
    height: 76px;
    border-radius: 16px;
    background: #e92504; /* rgb(233, 37, 4) */
    border-color: #e92504;
    color: #fff;
  }
}
</style>
